import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      'Software Engineer': 'Software Engineer',
      'AI/ML Focus': 'AI/ML Focus',
      'About': 'About',
      'Skills': 'Skills',
      'Projects': 'Projects',
      'Contact': 'Contact',
      'Download my Resume': 'Download my Resume',
      'Scroll to Explore': 'Scroll to Explore',
    }
  },
  de: {
    translation: {
      'Software Engineer': 'Software-Ingenieur',
      'AI/ML Focus': 'KI/ML-Fokus',
      'About': 'Über mich',
      'Skills': 'Fähigkeiten',
      'Projects': 'Projekte',
      'Contact': 'Kontakt',
      'Download my Resume': 'Meinen Lebenslauf herunterladen',
      'Scroll to Explore': 'Scrollen um zu Erkunden',
    }
  },
  fr: {
    translation: {
      'Software Engineer': 'Ingénieur Logiciel',
      'AI/ML Focus': 'Spécialisation IA/ML',
      'About': 'À propos',
      'Skills': 'Compétences',
      'Projects': 'Projets',
      'Contact': 'Contact',
      'Download my Resume': 'Télécharger mon CV',
      'Scroll to Explore': 'Défiler pour Explorer',
    }
  },
  ar: {
    translation: {
      'Software Engineer': 'مهندس برمجيات',
      'AI/ML Focus': 'تركيز على الذكاء الاصطناعي/التعلم الآلي',
      'About': 'عني',
      'Skills': 'المهارات',
      'Projects': 'المشاريع',
      'Contact': 'اتصل بي',
      'Download my Resume': 'تحميل سيرتي الذاتية',
      'Scroll to Explore': 'قم بالتمرير للاستكشاف',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already safes from XSS
    }
  });

export default i18n; 